import React from "react"

function CTAB() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={151}
        y={40}
        width={93}
        height={70}
        rx={2}
        fill="var(--base-200)"
      />
      <rect
        x={20}
        y={61}
        width={86}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={70}
        width={66}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={79}
        width={106}
        height={4}
        rx={2}
        fill="var(--base-500)"
      />
      <rect x={20} y={87} width={97} height={4} rx={2} fill="var(--base-500)" />
      <rect
        x={160}
        y={91}
        width={75}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
      <rect
        x={160}
        y={76}
        width={75}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={160}
        y={61}
        width={75}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <rect
        x={160}
        y={50}
        width={40}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default CTAB;
